import NewsSnippet from './newsSnippet'

export default NewsSnippet
